import { env } from 'shared/env';

import { createApiClient } from './axios';

export const api = createApiClient({
  baseURL: env('REACT_APP_API_URL'),
});
